<div class="content" #content woa-element-width [class.button]="buttonMode()"
     [woa-css-var]="{
         '--themed-loyalty-card-body-padding': ['--woa-' + cardTheme() + '-themed-loyalty-card-body-padding', '--woa-default-themed-loyalty-card-body-padding'],
         '--themed-loyalty-card-background-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-background-color', '--woa-default-themed-loyalty-card-background-color'],
         '--themed-loyalty-card-max-column-spec': ['--woa-' + cardTheme() + '-themed-loyalty-card-max-column-spec', '--woa-default-themed-loyalty-card-max-column-spec'],
         '--themed-loyalty-card-header-text-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-header-text-color', '--woa-default-themed-loyalty-card-header-text-color'],
         '--themed-loyalty-card-header-background-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-header-background-color', '--woa-default-themed-loyalty-card-header-background-color'],
         '--themed-loyalty-card-header-background-opacity': ['--woa-' + cardTheme() + '-themed-loyalty-card-header-background-opacity', '--woa-default-themed-loyalty-card-header-background-opacity'],
         '--themed-loyalty-card-footer-text-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-footer-text-color', '--woa-default-themed-loyalty-card-footer-text-color'],
         '--themed-loyalty-card-footer-background-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-footer-background-color', '--woa-default-themed-loyalty-card-footer-background-color'],
         '--themed-loyalty-card-footer-background-opacity': ['--woa-' + cardTheme() + '-themed-loyalty-card-footer-background-opacity', '--woa-default-themed-loyalty-card-footer-background-opacity'],
         '--themed-loyalty-card-placeholder-background-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-placeholder-background-color', '--woa-default-themed-loyalty-card-placeholder-background-color'],
         '--themed-loyalty-card-placeholder-border-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-placeholder-border-color', '--woa-default-themed-loyalty-card-placeholder-border-color'],
         '--themed-loyalty-card-placeholder-opacity': ['--woa-' + cardTheme() + '-themed-loyalty-card-placeholder-opacity', '--woa-default-themed-loyalty-card-placeholder-opacity'],
         '--themed-loyalty-card-stamp-color': ['--woa-' + cardTheme() + '-themed-loyalty-card-stamp-color', '--woa-default-themed-loyalty-card-stamp-color'],
         '--themed-loyalty-card-stamp-opacity': ['--woa-' + cardTheme() + '-themed-loyalty-card-stamp-opacity', '--woa-default-themed-loyalty-card-stamp-opacity'],
         '--themed-loyalty-card-stamp-icon': ['--woa-' + cardTheme() + '-themed-loyalty-card-stamp-icon', '--woa-default-themed-loyalty-card-stamp-icon'],
         '--themed-loyalty-card-stamp-icon-scale': ['--woa-' + cardTheme() + '-themed-loyalty-card-stamp-icon-scale', '--woa-default-themed-loyalty-card-stamp-icon-scale'],
         '--themed-loyalty-card-stamp-icon-rotate-factor': ['--woa-' + cardTheme() + '-themed-loyalty-card-stamp-icon-rotate-factor', '--woa-default-themed-loyalty-card-stamp-icon-rotate-factor']
     }">
    @if (!buttonMode()) {
        <div class="content-media">
            @if (card().image.id) {
                <img class="content-media-object" alt="" [woa-image-cache]="card().image">
            }
        </div>
    }
    <div class="content-details" [ngClass]="{'no-image': card().image.id == undefined}">
        @if (card().cardName && !buttonMode()) {
            <div class="content-details-header" id="loyalty-card-name-{{index()}}"
                 woa-responsive [fontScale]=".06">
                {{ card().cardName }}
            </div>
        }
        <div class="content-details-body">
            @if (card().cardType === LoyaltyCardType.STAMPS && stampRows() > 0) {
                <div class="content-details-body-stamps" #stamps
                     [woa-css-var]="{
                         '--rows': stampRows(),
                         '--columns': stampColumns(),
                         '--placeholder-container-size': stampPlaceholderContainerSize() + 'px'
                     }">
                    @for (cell of cells(); track cell) {
                        <div class="content-details-body-stamps-cell">
                            <div class="content-details-body-stamps-cell-container">
                                <div class="content-details-body-stamps-cell-container-placeholder"
                                     woa-responsive [fontScale]=".05">
                                    @if (cell < card().purchaseCount) {
                                        <woa-icon class="content-details-body-stamps-cell-container-placeholder-stamp"
                                                  [name]="stampIcon()" [grungeSeed]="stampName()(cell)"
                                                  [woa-css-var]="{'--rotation': stampRotation()(cell)}"></woa-icon>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (card().cardType === LoyaltyCardType.POINTS) {
                <div class="content-details-body-points">
                    <div class="content-details-body-points-progressbar" woa-responsive [fontScale]=".02">
                        <div class="content-details-body-points-progressbar-progress"
                             [woa-css-var]="{'--percentage': identityModel.cardCompletion()(card()) * 100}">
                        </div>
                    </div>
                </div>
            }
        </div>
        @if (card().cardName && buttonMode()) {
            <div class="content-details-button-label"
                 [ngClass]="{
                     'multi-row': card().cardType === LoyaltyCardType.STAMPS && stampRows() > 1,
                     'points': card().cardType === LoyaltyCardType.POINTS
                 }">
                {{ card().cardName }}
            </div>
        }
        @if (!buttonMode()) {
            <div class="content-details-footer" woa-responsive [fontScale]=".05">
                <span class="content-details-footer-text" id="loyalty-card-description-{{index()}}"
                      [innerHTML]="footerText() | translate: {
                          itemDescription: card().itemDescription || '{' + '{woa.message.loyalty-card.defaultItemDescription}' + '}',
                          purchaseCount: span('content-details-description-text-purchaseCount', 'loyalty-card-purchaseCount-' + index(), card().purchaseCount),
                          pointsAvailable: span('content-details-description-text-points', 'loyalty-card-points-' + index(), toScale(identityModel.currentMember().pointsBalance, 4)),
                          pointsRequired: span('content-details-description-text-points', 'loyalty-card-points-' + index(), toScale(card().pointsRequiredToRedeem, 4)),
                          remaining: span('content-details-description-text-remaining', 'loyalty-card-remaining-' + index(), card().cardType === LoyaltyCardType.STAMPS ? stampsRequired() : pointsRequired()),
                          stampsGoal: span('content-details-description-text-goal', 'loyalty-card-goal-' + index(), card().goal),
                          goalDescription: card().goalDescription || '{' + '{woa.message.loyalty-card.defaultGoalDescription}' + '}'
                      }">
                </span>
                @if (card().cardType === LoyaltyCardType.POINTS && card().pointsRequiredToRedeem <= identityModel.currentMember().pointsBalance) {
                    <woa-link class="content-details-footer-link"
                              [link]="'woa.button.loyalty-cards.redeem'" (onActivate)="onRedeem.emit()"></woa-link>
                }
            </div>
        }
    </div>
</div>
